// sort-imports-ignore
import "instrument";
// Inter is bundled with the app rather than loaded from Google Fonts, so
// visitors' IP addresses are not sent to Google.
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import { ApolloProvider } from "@apollo/client";
import App from "App";
import { ThemeProvider } from "contexts/ThemeContext";
import React from "react";
import "react-app-polyfill/stable";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { userClient } from "utils/jwt";

const container = document.getElementById("root") as Element;
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <ThemeProvider>
      <ApolloProvider client={userClient}>
        <App />
      </ApolloProvider>
    </ThemeProvider>
  </BrowserRouter>
);
